const translations = {
    fr: {
        title: "Réinitialisation du mot de passe",
        info: "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
        emailPlaceholder: "Votre email",
        sending: "Envoi...",
        send: "Envoyer",
        success: "Un email de réinitialisation a été envoyé (pensez à vérifier vos spams).",
        errorGeneric: "Une erreur s'est produite.",
        errorNetwork: "Erreur de connexion au serveur. Veuillez réessayer.",
        loginCta: "Me connecter"
    },
    en: {
        title: "Password reset",
        info: "Enter your email and we’ll send you a link to reset your password.",
        emailPlaceholder: "Your email",
        sending: "Sending...",
        send: "Send",
        success: "A reset email has been sent (don’t forget to check your spam).",
        errorGeneric: "An error occurred.",
        errorNetwork: "Server connection error. Please try again.",
        loginCta: "Log in"
    },
    de: {
        title: "Passwort zurücksetzen",
        info: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
        emailPlaceholder: "Ihre E-Mail",
        sending: "Senden...",
        send: "Senden",
        success: "Eine E-Mail zum Zurücksetzen wurde gesendet (bitte auch den Spam-Ordner prüfen).",
        errorGeneric: "Es ist ein Fehler aufgetreten.",
        errorNetwork: "Serververbindungsfehler. Bitte versuchen Sie es erneut.",
        loginCta: "Anmelden"
    },
    es: {
        title: "Restablecimiento de contraseña",
        info: "Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
        emailPlaceholder: "Tu correo electrónico",
        sending: "Enviando...",
        send: "Enviar",
        success: "Se ha enviado un correo de restablecimiento (no olvides revisar tu carpeta de spam).",
        errorGeneric: "Se ha producido un error.",
        errorNetwork: "Error de conexión con el servidor. Por favor, inténtalo de nuevo.",
        loginCta: "Iniciar sesión"
    },
    it: {
        title: "Reimpostazione della password",
        info: "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
        emailPlaceholder: "La tua email",
        sending: "Invio...",
        send: "Invia",
        success: "È stata inviata un'email di reimpostazione (controlla anche la cartella spam).",
        errorGeneric: "Si è verificato un errore.",
        errorNetwork: "Errore di connessione al server. Riprova.",
        loginCta: "Accedi"
    }
}

export default translations;